import React from 'react';

const TONE_CLASSES = {
  success: 'bg-success/20 text-success',
  danger: 'bg-error/20 text-error',
  error: 'bg-error/20 text-error',
  warning: 'bg-warning/20 text-warning-content',
};

const StatusBadge = ({ statusLabel, statusTone, label, tone, message }) => {
  const actualLabel = label || statusLabel || 'Unknown';
  const actualTone = tone || statusTone || 'ghost';

  const badgeClass = TONE_CLASSES[actualTone] ?? 'bg-base-200 text-base-content';

  return (
    <span 
      className={`${badgeClass} border-none badge-sm uppercase font-bold px-3 py-3 rounded-full`}
      title={message}
    >
      {actualLabel}
    </span>
  );
};

export default StatusBadge;
